// web-v2/src/lib/palette-owner.js
//
// WHICH Cmd+K OWNS THE KEYS. Two palettes are mounted in the AppShell: the V2
// SearchPalette (shared/SearchPalette.jsx, /api/tracon/search, landing on the
// V2 screens) and the V3 palette (v3/V3SearchPalette.jsx, /api/v3/search,
// landing on the v3 account page). Both read this one function with the flag
// (lib/v3-flag.js useV3Enabled) and register their key handler and their
// 'search-palette:open' listener only while it names them, so Cmd+K, Ctrl+K
// and the TopBar search button open exactly one palette on every route.
// V3 Overnight 3 (lane C): the v3 palette owns the keys on EVERY route when
// the flag is on, and never when it is off or not known (null: the classic
// palette, which works either way). The handoff is here and nowhere else
// (guards: tests/v3-search-palette.test.js, tests/v3-front-door.test.js).
export const V2_PALETTE = 'v2';
export const V3_PALETTE = 'v3';

export function paletteOwner(v3Enabled) {
  return v3Enabled === true ? V3_PALETTE : V2_PALETTE;
}
